import React from "react";
import { useTranslation } from "react-i18next";
import TestimonialCard from "../components/TestimonialCard";

function Testimonials() {
  const { t } = useTranslation();

  // Ab JSON file se nahi, locale file se data aayega — fully translated!
  const testimonials = t("testimonialsList", { returnObjects: true });

  return (
    <div className="page testimonials-page">

      {/* ===== PAGE HERO ===== */}
      <section className="page-hero">
        <div className="section-label">{t("testimonials.label")}</div>
        <h1>{t("testimonials.title")}</h1>
        <p>{t("testimonials.subtitle")}</p>
      </section>

      {/* ===== ALL TESTIMONIALS ===== */}
      <section className="section-block">
        <div className="container">
          <div className="testimonials-grid">
            {Array.isArray(testimonials) && testimonials.map((test) => (
              <TestimonialCard key={test.id} {...test} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Testimonials;
